up.compiler('.js-popup_link', function (element) {
  function onClick(e) {
    e.preventDefault()
    const features = `width=${element.dataset.windowWidth},height=${element.dataset.windowHeight}`
    window.open(element.getAttribute('href'), element.getAttribute('target'), features)
  }

  element.addEventListener('click', onClick)

  return function () {
    element.removeEventListener('click', onClick)
  }
})
